import React from 'react';

// import components
import VideoCards from 'components/partials/video-cards';

// import types
import { ImageContentCardData } from "types/image-content-card-data";
import { IntroHeadlineProps } from "types/intro-headline-props";

// import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";
import { isGatsbyImageData } from 'helpers/is-gatsby-image';

const VideoCardsRowBuilder: React.FC<{ videoCardsRowData?: Queries.VideoCardsRowBlockFragment }> = ({ videoCardsRowData }) => {

    if (!videoCardsRowData) return null;

    const patternModifierClass = videoCardsRowData.colorOption ? `bg-brand-${videoCardsRowData.colorOption}` : 'bg-brand-red';

    const linkData = getLinkDataFromDato(videoCardsRowData.link?.link);

    const intro: IntroHeadlineProps = {
        headline: videoCardsRowData.heading ?? '',
        buttonProps: linkData ? {
            buttonText: linkData?.label || 'Error: Missing label',
            buttonUrl: linkData?.url || '#',
            target: linkData?.target || '_self',
        } : undefined
    };

    const cards = videoCardsRowData.videos?.map((video): ImageContentCardData | undefined => {

        if (!video) return undefined;

        let image = isGatsbyImageData(video?.thumbnailImageOverride?.gatsbyImageData) ? video.thumbnailImageOverride?.gatsbyImageData : undefined;

        let imageOverride = {
            image: image, // This is now guaranteed to be IGatsbyImageData | undefined
            alt: video?.thumbnailImageOverride?.alt ?? '',
            thumbnailUrl: undefined,
            thumbnailHeight: undefined,
            thumbnailWidth: undefined,
        };

        let thumbnailFallback = {
            image: undefined, // Explicitly set to undefined to match expected type
            alt: video?.title ?? '',
            thumbnailUrl: video?.externalVideoLink?.thumbnailUrl ?? undefined,
            thumbnailHeight: video?.externalVideoLink?.height ?? undefined,
            thumbnailWidth: video?.externalVideoLink?.width ?? undefined,
        };

        // Use imageOverride if image is defined, otherwise use thumbnailFallback
        let thumbnailData = image ? imageOverride : thumbnailFallback;

        // Use title override from Dato, or external video title otherwise
        let headline = video.title || video.externalVideoLink?.title || 'Error: No Title';

        return {
            id: video.id,
            headline: headline,
            videoUrl: video.externalVideoLink?.url ?? undefined,
            cardImage: thumbnailData.image,
            videoThumbnailUrl: thumbnailData.thumbnailUrl,
            videoThumbnailWidth: thumbnailData.thumbnailWidth,
            videoThumbnailHeight: thumbnailData.thumbnailHeight,
            videoThumbnailAlt: thumbnailData.alt
        };

    }).filter((card): card is ImageContentCardData => card !== undefined) || [];

    return (
        <VideoCards
            patternModifierClass={patternModifierClass}
            introHeadlineProps={intro}
            cards={cards} />
    );
}

export default VideoCardsRowBuilder;
